export default "__VITE_ASSET__CRueBs6P__"